var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55554 3C8.04646 3 8.44442 3.40294 8.44442 3.9V4.8H11.1111V3.9C11.1111 3.40294 11.509 3 12 3C12.4909 3 12.8888 3.40294 12.8888 3.9V4.8H15.5555V3.9C15.5555 3.40294 15.9535 3 16.4444 3C16.9353 3 17.3333 3.40294 17.3333 3.9L17.3333 4.8C18.806 4.8 19.9999 6.00883 19.9999 7.5V11.8714C19.9999 12.3685 19.602 12.7714 19.111 12.7714C18.6201 12.7714 18.2222 12.3685 18.2222 11.8714V11.7429H5.77777V18.3C5.77777 18.7971 6.17574 19.2 6.66665 19.2H10.9841C11.475 19.2 11.873 19.6029 11.873 20.1C11.873 20.5971 11.475 21 10.9841 21H6.66665C5.1939 21 4 19.7912 4 18.3V7.5C4 6.00883 5.1939 4.8 6.66665 4.8L6.66665 3.9C6.66665 3.40294 7.06462 3 7.55554 3ZM5.77777 7.5C5.77777 7.00294 6.17574 6.6 6.66665 6.6V7.5C6.66665 7.99706 7.06462 8.4 7.55554 8.4C8.04646 8.4 8.44442 7.99706 8.44442 7.5V6.6H11.1111V7.5C11.1111 7.99706 11.509 8.4 12 8.4C12.4909 8.4 12.8888 7.99706 12.8888 7.5V6.6H15.5555V7.5C15.5555 7.99706 15.9535 8.4 16.4444 8.4C16.9353 8.4 17.3333 7.99706 17.3333 7.5L17.3333 6.6C17.8242 6.6 18.2222 7.00294 18.2222 7.5V9.94286H5.77777V7.5Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8317 15.2269C20.1191 14.824 20.0295 14.2614 19.6315 13.9704C19.2335 13.6794 18.6779 13.7701 18.3905 14.1731L15.195 18.6528L13.5599 16.747C13.238 16.3717 12.6765 16.3318 12.3059 16.6578C11.9353 16.9837 11.8959 17.5522 12.2178 17.9274L14.5882 20.6902C14.7661 20.8977 15.028 21.0114 15.2991 20.9991C15.5702 20.9868 15.8209 20.8497 15.9798 20.6269L19.8317 15.2269Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.f35335e87b9f691814eedd3d1e8f636b.svg";
export { ForwardRef as ReactComponent };